// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"styles_paginationContainer__hkUR_","pagination":"styles_pagination__bKog0","fromTo":"styles_fromTo__uh5Ee"};